/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { getProxyUrl } from '../../utils/image';
import { usePlayer } from '../../hooks/player';
import { getPlayerUrlById } from '../../utils/routes';
import { useTeamLogo } from '../../hooks/team';

function LeadersHero({ player, showShirtNumber = true }) {
  const { id, givenName, surName, imageHalf200, teamAbbrv } = player;
  const [teamLogo] = useTeamLogo(teamAbbrv);
  const [fullPlayer] = usePlayer(id);
  const shirtNumber = fullPlayer?.currentClub?.[0]?.shirtNumber || '#';
  const playerUrl = getPlayerUrlById(id);

  return (
    <div className="player-bust">
      <div className="player-bust__images--front-page">
        <img
          alt="player"
          className="player-bust__player-image--front-page"
          src={getProxyUrl(
            imageHalf200 ||
              '/wp-content/themes/sef-leagues/images/player_no_image.png',
            165,
            156
          )}
        />
        <img alt="team" className="player-bust__team-image" src={teamLogo} />
      </div>
      <a
        style={{ pointerEvents: playerUrl ? 'auto' : 'none' }}
        href={playerUrl}
        className="player-bust__info text-decoration-none"
      >
        {shirtNumber && showShirtNumber ? (
          <div className="player-bust__number m-0">{shirtNumber}</div>
        ) : null}
        <div
          className="player-bust__name m-0"
          style={!showShirtNumber ? { padding: 0 } : {}}
        >
          <div className="heading-h6 text-transform-none m-0">{givenName}</div>
          <div className="heading-h5 text-transform-none m-0">{surName}</div>
        </div>
      </a>
    </div>
  );
}

LeadersHero.propTypes = {
  player: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    givenName: PropTypes.string.isRequired,
    surName: PropTypes.string.isRequired,
    imageHalf200: PropTypes.string.isRequired,
  }).isRequired,
  showShirtNumber: PropTypes.bool,
};
LeadersHero.defaultProps = {
  showShirtNumber: true,
};

export default LeadersHero;
